module.exports = __webpack_public_path__ + "static/paris-021.thumb-71544b553395db04c45b55fdd89a2255.jpg";